export function sortTreatments(a, b) {
  const { treatmentPlan: aTreatmentPlan = 0, treatmentSession: aTreatmentSession = 0 } = a;
  const { treatmentPlan: bTreatmentPlan = 0, treatmentSession: bTreatmentSession = 0 } = b;

  return (
    (bTreatmentPlan < aTreatmentPlan) - (aTreatmentPlan < bTreatmentPlan) ||
    (bTreatmentSession < aTreatmentSession) - (aTreatmentSession < bTreatmentSession)
  );
}
